import React from "react";
import _ from 'lodash';

import { v4 as uuidv4 } from 'uuid';

import Grid from "@material-ui/core/Grid";
import RadioQuestion, {RadioCardsQuestion} from "../../question/RadioQuestion";
import LabelFormElement from "../../formElement/LabelFormElement";
import {isRequiredQuestion} from "../../../../../utils";
import InputFormElement from "../../formElement/InputFormElement";
import {countriesChoices, CountryFormElement} from "../../question/CountrySelectQuestion/CountrySelectQuestion";
import PlusBackgroundIcon from "../../../../../../../images/PlusBackgroundIcon";
import IconButton from '../../../../../../../components/Buttons/IconButton';
import MinusBackgroundIcon from "../../../../../../../images/MinusBackgroundIcon";
import {getSubSystemConfigItem} from "../../../../../../../utils/utils";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import PrimaryButton from "../../../../../../../components/Buttons/PrimaryButton";
import BcaIconButton from "../../../../../../../components/Buttons/BcaIconButton/BcaIconButton";


const TaxIdentifiersTable = ({question, onAnswerChange, maxRows, isNewDesign}) => {

  const answer = question.answer || [];

  const cleanError = (taxItemId, fieldName) => {
    if (_.isEmpty(question.error)) {
      return;
    }

    if (_.isString(question.error) || _.isArray(question.error)) {
      question.error = null;
    } else {
      _.set(question.error, `${taxItemId}.${fieldName}`, null);
    }
  }

  const onChange = (value, key, index, taxIdItem) => {
    const answer = question.answer || [];

    _.set(answer, `${index}.${key}`, value);
    cleanError(taxIdItem.id, key);

    onAnswerChange(question.uid, answer);
  }

  const onCountryChange = (code, index, taxIdItem) => {
    const answer = question.answer || [];

    const country = countriesChoices.find((option) => option.id == code);

    _.set(answer, `${index}.country`, country);
    cleanError(taxIdItem.id, 'country');

    onAnswerChange(question.uid, answer);
  }

  const showAddButton = (() => {

    if (!answer || _.isEmpty(answer)) {
      return true;
    }

    const lastTaxId = answer[answer.length - 1];
    if (_.isEmpty(lastTaxId.tax_id) && _.isEmpty(lastTaxId.country)) {
      return false;
    }

    return answer.length < maxRows;
  })()

  const taxCountryInfo = (() => {
    const info = getSubSystemConfigItem('trading', 'tax_country_info');

    return info || {};
  })();

  const tableInfoText = (() => {
    return answer.map((item) => {

      const countryCode = _.get(item, 'country.id');

      if (taxCountryInfo.hasOwnProperty(countryCode)) {
        return (
          <p dangerouslySetInnerHTML={{__html: taxCountryInfo[countryCode]}} />
        )
      }
      return null
    })
  })();

  const getTableRows = () => {

    return answer.map((taxIdItem, index) => (
      <Grid item xs={12} sm={8} key={taxIdItem.id}>
        <Grid container spacing={2}>
          <Grid item xs={5}>
            <InputFormElement
              disabled={question.disabled}
              value={taxIdItem.tax_id || ''}
              onChange={(value) => onChange(value, 'tax_id', index, taxIdItem)}
              error={_.get(question, `error.${taxIdItem.id}.tax_id`)}
              custom_classes={question.custom_classes}
            />
          </Grid>
          <Grid item xs={5} style={{display: 'flex'}}>
            <CountryFormElement
              value={_.get(taxIdItem, 'country.id') || ''}
              required={true}
              onChange={(value) => onCountryChange(value, index, taxIdItem)}
              disabled={question.disabled || taxIdItem.country_disabled}
              error={_.get(question, `error.${taxIdItem.id}.country`)}
              custom_classes={question.custom_classes}
            />
          </Grid>
          {answer.length > 1 && !taxIdItem.country_disabled && (
            <Grid item xs={2}>
              {isNewDesign
                ? <BcaIconButton
                  icon={<i className={'fal fa-trash'} />}
                  onClick={() => removeTaxId(taxIdItem.id)}
                  color={'secondary'}
                  fontSize={24}
                />
                : <IconButton
                    component={MinusBackgroundIcon}
                    style={{paddingRight: 0, marginTop: 5}}
                    onClick={() => removeTaxId(taxIdItem.id)}
                    size={36}
                  />
                }
            </Grid>
          )}
        </Grid>
      </Grid>
    ))

  }

  const addNewTaxId = () => {
    const newAnswer = [...answer, {
      tax_id: null,
      country: null,
      id: uuidv4(),
    }]

    onAnswerChange(question.uid, newAnswer)
  }

  const removeTaxId = (id) => {
    const newAnswer = _.filter(answer, (item) => item.id != id);
    onAnswerChange(question.uid, newAnswer)
  }

  const isGeneralError = !_.isEmpty(question.error) && (_.isArray(question.error) || _.isString(question.error));
  const required = isRequiredQuestion(question) || question.required_check;

  return (
    <>
      <LabelFormElement
        label={question.question_text}
        customClasses={question.custom_classes}
        error={isGeneralError}
      />
      <Grid container>
        {!_.isEmpty(tableInfoText) && (
          <Grid item xs={12}>
            {tableInfoText}
          </Grid>
        )}
        <Grid item xs={12} sm={8}>
          <Grid container spacing={2}>
            <Grid item xs={5}>
              <LabelFormElement
                label="SteuerID (TIN)"
                customClasses={question.custom_classes}
                style={{paddingBottom: 5}}
                required={required}
              />
            </Grid>
            <Grid item xs={5}>
              <LabelFormElement
                label="Land"
                customClasses={question.custom_classes}
                style={{paddingBottom: 5}}
                required={required}
              />
            </Grid>
          </Grid>
        </Grid>
        {getTableRows()}
        {showAddButton && (
          <Grid item xs={12} sm={8}>
            <Grid container spacing={2}>
              <Grid item xs={10} justify={isNewDesign ? "center" : "flex-end"} style={{display: 'flex'}}>
                {isNewDesign
                  ? <PrimaryButton
                    text={'Weitere SteuerID hinzufügen'}
                    variant={'text'}
                    icon={<i className={'fal fa-plus'}/>}
                    onButtonClick={addNewTaxId}
                  />
                  : <IconButton
                    component={PlusBackgroundIcon}
                    style={{paddingRight: 0}}
                    onClick={addNewTaxId}
                    size={36}
                  />
                }
              </Grid>
            </Grid>
          </Grid>
        )}
        {isGeneralError && (
          <Grid item xs={12} sm={8}>
            <FormControl error={true}>
              <FormHelperText>{ question.error }</FormHelperText>
            </FormControl>
          </Grid>
        )}
      </Grid>
    </>
  )
}

const CustomerTaxesStep = props => {
  const {
    onAnswerChange,
    questions: [
      steuerpflichtig,
      tax_identifiers
    ],
    dataService
  } = props;

  const isNewDesign = dataService.isNewDesign;

  const handleTaxIdentifierChange = (steuerpflichtig) => {
    const taxIdentifiersAnswer = dataService.initTaxIdentifiers(tax_identifiers, steuerpflichtig);
    onAnswerChange(tax_identifiers.uid, taxIdentifiersAnswer);
  }

  const handleSteuerpflichtigChange = (question, answer) => {
    onAnswerChange(question, answer);
    handleTaxIdentifierChange(answer);
  };

  const RadioComponent = isNewDesign ? RadioCardsQuestion : RadioQuestion;

  if (steuerpflichtig.answer === '1') {
    tax_identifiers.question_text = 'Bitte teilen Sie uns die Steueridentifikationsnummer (TIN) mit';
  } else {
    tax_identifiers.question_text = "Bitte teilen Sie uns die Steueridentifikationsnummer(n) (TIN) und das zugehörige steuerpflichtige Land Ihres Kunden mit";
  }

  return (
    <Grid container spacing={6} direction={"column"}>
      <Grid item xs={12}>
        <RadioComponent
          question={steuerpflichtig}
          onAnswerChange={handleSteuerpflichtigChange}
        />
      </Grid>
      {!!steuerpflichtig.answer && (
        <Grid item xs={12}>
          <TaxIdentifiersTable
            question={tax_identifiers}
            onAnswerChange={onAnswerChange}
            maxRows={steuerpflichtig.answer === "1" ? 1 : 2}
            isNewDesign={isNewDesign}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default CustomerTaxesStep;
